<template>
    <div class="rechner_wrapper">

        <RechnerTemplate :steps="steps">
            <div slot="success-info">
                Well done, all suceeded
            </div>
        </RechnerTemplate>
    </div>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
  import rechnerMixin from '../rechnerMixin'
  import Step_bauherren_I from './Step_bauherren_I'

  import Step_Tarifwahl from '../common/Step_Tarifwahl'
  import Step_VorVers from '../common/Step_VorVers'
  import Step_VersNehmer from '../common/Step_VersNehmer'
  import Step_BankVerb from '../common/Step_BankVerb'
  import Step_Abschluss from '../common/Step_Abschluss'


  // import _ from 'lodash'

  export default {
    //========================================================================================================
    mixins: [rechnerMixin],
    //========================================================================================================
    name: 'Rechner-bauherren',
    //========================================================================================================
    components: {Step_bauherren_I, Step_Tarifwahl, Step_VorVers, Step_VersNehmer, Step_BankVerb, Step_Abschluss},
    //========================================================================================================
    data: function () {
      return {
        test: 1,
      }

    }, //=====================================================================================================
    computed: {}, //==========================================================================================
    methods: {}, //===========================================================================================


  }
  //¯
  /*
   ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯
   ¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨
   ………………………………………………………………………
   •••••••••••••••••••••••••••
   »»»»»»»»»»»»»»»»»»»»»»»»»»
   ­­­­­­­­­­­­­­­­­­­­­­­­­­
   ———————————————————————————

   –––––––––––––––––––––
   */
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style type="less">
    /*
    .stepper__step {
        min-height: 6.1em;
    }

    .stepper__label span.main-text {
        padding-left: 35px;
        margin-left: -35px;
        cursor: pointer;
        z-index: 1;

    }

    .rechner {

    }

    .rechner-content {
        position: relative;
        width: 100%;
        height: 300px;
        border: 2px solid red;
        overflow: hidden;
    }

    .step {
        width: 100%;
        height: 50%;
        position: absolute;
        left: 0;
        top: 0;
        background: #eeeeee;
        border: solid 3px purple;
    }

    .rechner-footer {
        border: 2px solid blue;

    }

    .fadeIn-enter-active {
        transition: all 1s ease-in;
        opacity: 1;
    }

    .fadeIn-enter

    {

        opacity: 0;
    }

    */
</style>
